module.exports = __webpack_public_path__ + "1f4b26bcad91ec8004a044d384b720fd.pdf";